exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-page .vue-grid-item[data-v-34e8d35e]{-webkit-transition:none;transition:none}", ""]);

// exports
